/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DisbursementService {

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppDisbursementCallBackRequest(
requestBody?: Wealthlane_AwardSettlementService_Dtos_Disbursement_DisbursementCallbackRequestDto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/disbursement/call-back-request',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param disbursementStatusId 
     * @param disbursementContainerStatusId 
     * @param companyIds 
     * @param date 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppDisbursementExportDisbursement(
disbursementStatusId?: Array<number>,
disbursementContainerStatusId?: Array<number>,
companyIds?: Array<string>,
date?: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/disbursement/export-disbursement',
            query: {
                'DisbursementStatusId': disbursementStatusId,
                'DisbursementContainerStatusId': disbursementContainerStatusId,
                'CompanyIds': companyIds,
                'Date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param formData 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppDisbursementImportDisbursements(
formData?: {
File?: Blob;
},
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericResponseDtos_GenericTaskResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/disbursement/import-disbursements',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
